/**
 * sessionStorage helpers for the direct-OIDC popup login flow.
 *
 * `LoginsPanel` (in the opener tab) and `LoginCallbackPage` (in the popup)
 * share this shape via `sessionStorage`, mirroring the PKCE state/verifier
 * handling in features/auth/context/AuthContext.handleOAuthCallback.
 */

import { STORAGE_KEYS } from '@utils/constants';

export interface LoginFlowState {
  state: string;
  code_verifier: string;
  provider: string;
  redirect_uri: string;
}

/** postMessage type sent by the popup to the opener on successful completion. */
export const LOGIN_COMPLETE_MESSAGE = 'sanctum-login-complete';

export function saveLoginFlow(flow: LoginFlowState): void {
  sessionStorage.setItem(STORAGE_KEYS.LOGIN_FLOW, JSON.stringify(flow));
}

export function readLoginFlow(): LoginFlowState | null {
  const raw = sessionStorage.getItem(STORAGE_KEYS.LOGIN_FLOW);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as LoginFlowState;
  } catch {
    return null;
  }
}

export function clearLoginFlow(): void {
  sessionStorage.removeItem(STORAGE_KEYS.LOGIN_FLOW);
}
